import { render, staticRenderFns } from "./San.vue?vue&type=template&id=e8d48986&scoped=true&"
import script from "./San.vue?vue&type=script&lang=js&"
export * from "./San.vue?vue&type=script&lang=js&"
import style0 from "./San.vue?vue&type=style&index=0&id=e8d48986&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d48986",
  null
  
)

export default component.exports